<template>
    <header class="header">
        <div class="container header-container" aria-label="Zaglavlje">
            <div class="logo-navicon-wrap">
                <a href="/">
                    <img src="../assets/uns-logo.png" alt="UNS" class="logo-img" aria-label="Udruženje novinara Srbije">
                </a>
            </div>
            <button type="button" class="nav-icon" :title="navOpen ? 'Zatvori navigaciju' : 'Navigacija'"
                :aria-label="navOpen ? 'Zatvori navigaciju' : 'Navigacija'" @click="toggleNav" :class="{ 'is-open': navOpen }">
                <span class="nav-icon-line"></span>
                <span class="nav-icon-line"></span>
                <span class="nav-icon-line"></span>
            </button>
            <nav class="nav-wrap desktop-navigation" aria-label="Glavna navigacija" v-if="!isMobile">
                <ul class="nav" data-nav>
                    <li class="nav-item">
                        <button class="nav-item nav-link" @click='dropDown' :class="{ 'is-dropdown-open': dropdownOpen }">Претрага</button>
                        <ul class="nav-dropdown" :class="{ 'is-visible': dropdownOpen }" data-dropdown>
                            <li class="secondary-nav-item"><router-link to="/" class="secondary-nav-link first" @click="closeDropdown">По конкурсима</router-link></li>
                            <!-- <li class="secondary-nav-item"><router-link to="/pretraga/mediji" class="secondary-nav-link" @click="closeDropdown"> По називу медија</router-link></li> -->
                            <li class="secondary-nav-item"><router-link to="/pretraga/podnosioc-projekta" class="secondary-nav-link" @click="closeDropdown">По подносиоцу пројекта</router-link></li>
                            <li class="secondary-nav-item"><router-link to="/pretraga/komisija" class="secondary-nav-link last" @click="closeDropdown">По комисији</router-link></li>
                        </ul>
                    </li>

                    <li class="nav-item">
                    <router-link to="/upiti" class="nav-link">Упити</router-link>
                    </li>
                    <li class="nav-item">
                    <router-link to="/statistika" class="nav-link">Статистика</router-link>
                    </li>
                </ul>
            </nav>

            <div class="mobile-nav-overlay"
                v-if="navOpen"
                @click="closeNav"
                aria-hidden="true"></div>

            <nav class="mobile-navigation" :class="{ 'is-open': navOpen }" aria-label="Glavna navigacija">
                <ul class="mobile-main-list">                   
                    <li class="mobile-nav-item first">Претрага
                        <ul class="mobile-secondary-items">
                            <li class="mobile-nav-item"><router-link to="/" class="mobile-nav-link" @click="closeNav">По конкурсима</router-link></li>
                            <!-- <li class="mobile-nav-item"><router-link to="/pretraga/mediji" class="mobile-nav-link" @click="closeNav"> По називу медија</router-link></li> -->
                            <li class="mobile-nav-item"><router-link to="/pretraga/podnosioc-projekta" class="mobile-nav-link" @click="closeNav">По подносиоцу пројекта</router-link></li>
                            <li class="mobile-nav-item"><router-link to="/pretraga/komisija" class="mobile-nav-link" @click="closeNav">По комисији</router-link></li>
                        </ul>
                    </li>
                    <li class="mobile-nav-item mobile-link"><router-link to="/upiti" class="nav-link" @click="closeNav">Упити</router-link></li>
                    <li class="mobile-nav-item mobile-link"><router-link to="/statistika" class="nav-link" @click="closeNav">Статистика</router-link></li>
                </ul>
            </nav>
            

        </div>
    </header>
</template>

<script>
export default {

     data() {
    return {
      dropdownOpen: false,
      navOpen: false,
      windowWidth: window.innerWidth,
    };
  },
  computed: {
    isMobile() {
      return this.windowWidth < 768;
    },
  },
  methods: {
    dropDown() {
      this.dropdownOpen = !this.dropdownOpen;
    },
    closeDropdown() {
      this.dropdownOpen = false;
    },
    toggleNav() {
      this.navOpen = !this.navOpen;
    },
    closeNav() {
        this.navOpen = false;
        this.dropdownOpen = false;
    },
    handleResize() {
      this.windowWidth = window.innerWidth;

      if (this.windowWidth >= 768 && this.navOpen) {
        this.closeNav();
      }
    },
    handleClickOutside(event) {
      const dropdown = this.$el.querySelector('[data-dropdown]');
      const button = this.$el.querySelector('.nav-link');

        if (
            this.dropdownOpen &&
            !dropdown.contains(event.target) &&
            !button.contains(event.target)
        ) {
            this.closeDropdown();
        }
        },
    },

    mounted() {
        document.addEventListener('click', this.handleClickOutside);
        window.addEventListener('resize', this.handleResize);
    },
    beforeUnmount() {
        document.removeEventListener('click', this.handleClickOutside);
        window.removeEventListener('resize', this.handleResize);
    },

    watch: {
        navOpen(newVal) {
            if (newVal) {
            document.body.classList.add('menu-open');
            } else {
            document.body.classList.remove('menu-open');
            }
        }
        }
    
};
</script>

